<template>
  <div v-if="branchDetails">
    <portal to="toolbar-title">
      {{ branchDetails.BranchAddress }}, {{ branchDetails.BranchAreaName }}
    </portal>
    <portal to="toolbar-actions">
    </portal>
    <portal to="header-content">
      <v-row>

        <big-round-button color="primary" class="mr-2 mb-2" icon="mdi-domain" text="ΚΤΗΡΙΟ"
                          :to="'/building/'+branchDetails.Branch_ID"></big-round-button>
        <big-round-button color="primary" class="mr-2 mb-2" icon="mdi-compare-horizontal" text="ΚΙΝΗΣΕΙΣ"
                          :to="'/building/'+branchDetails.Branch_ID+'/partnerMoves'"
                          v-if="userDetails.Allows.ShowDeptsMoves"
        ></big-round-button>
      </v-row>
    </portal>
    <v-row>
      <v-col lg="12" sm="12" md="12" cols="12" style="padding-top:0">
        <router-view>
        </router-view>
      </v-col>
    </v-row>
  </div>

</template>

<script>
import buildingMixin from "../mixins/buildingMixin"
import BuildingCard from "../components/BuildingCard"
import BuildingDetails from "@/views/Buildings/views/BuildingDetails";
import Expandable from "@/wl-core/components/Expandable";
import {mapGetters} from "vuex";
import Page from "@/components/templates/Page";
import BigRoundButton from "@/components/BigRoundButton";

export default {
  name: "Building",
  components: {BigRoundButton, Page, Expandable, BuildingDetails, BuildingCard},
  computed: {
    ...mapGetters([
      "isMobile",
      "userDetails"
    ])
  },
  mixins: [
    buildingMixin
  ]
}
</script>

<style scoped>

</style>
